<form [formGroup]="form" (submit)="save.emit(form.value)">
	<app-form-inputs
		[filter]="form.filter"
		[controls]="form.controls"
		[form]="form"
	></app-form-inputs>

	@if (showFooter()) {
	<button
		type="submit"
		nbButton
		class="float-end"
		status="secondary"
		size="medium"
		[disabled]="!form.valid"
	>
		{{ form?.footer.submit.text | translate }}
	</button>
	} @if (showFooter() && showClearButton()) {
	<button
		type="button"
		nbButton
		outline
		class="float-end me-2 bg-white"
		status="primary"
		size="medium"
		(click)="resetForm()"
	>
		{{ form?.footer.clear.text | translate }}
	</button>
	}

	<input #htmlInputSubmit type="submit" [ngStyle]="{display: 'none'}" />
</form>
